import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
var ServerConfiguration = /** @class */ (function () {
    function ServerConfiguration(_document) {
        this._document = _document;
    }
    Object.defineProperty(ServerConfiguration.prototype, "baseHref", {
        get: function () {
            var base = this._document.querySelector('base');
            return base && base.href || '';
        },
        enumerable: true,
        configurable: true
    });
    ServerConfiguration.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ServerConfiguration_Factory() { return new ServerConfiguration(i0.ɵɵinject(i1.DOCUMENT)); }, token: ServerConfiguration, providedIn: "root" });
    return ServerConfiguration;
}());
export { ServerConfiguration };
